import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Scanning options", -1)
const _hoisted_2 = { class: "container" }

import { save, close } from "ionicons/icons";
import { reactive } from "vue";
import {
  IonList,
  IonItem,
  IonLabel,
  IonRow,
  IonCol,
  IonGrid,
  IonRadioGroup,
  IonRadio,
  IonNote,
  IonButton,
  IonLoading,
  IonFooter,
  IonIcon,
} from "@ionic/vue";
import { useAppStore } from "@/stores/app";
import { useWindowWidth } from "@/composition/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'Scan',
  emits: ["cancel"],
  setup(__props, { emit }) {



const { isMobile } = useWindowWidth();

const state = reactive({
  loading: false,
});

const appStore = useAppStore();

const cancel = () => {
  emit("cancel");
};

const checkinModeChange = (val: "slow" | "fast") => {
  appStore.setCheckinMode(val);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(IonItem), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonList), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRadioGroup), {
            value: _unref(appStore).settings.checkin_mode,
            onIonChange: _cache[0] || (_cache[0] = (event) => checkinModeChange(event.target.value))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Fast scanning")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonRadio), { value: "fast" }),
                  _createVNode(_unref(IonNote), { slot: "helper" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Read one QR code after another at top speed. ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Print guest labels")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonRadio), { value: "slow" }),
                  _createVNode(_unref(IonNote), { slot: "helper" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" See guest details after scanning and print labels. ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      })
    ]),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("section", null, [
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonButton), {
                              expand: "block",
                              color: "light",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (cancel()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(close)
                                }, null, 8, ["icon"]),
                                _createTextVNode(" Cancel ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonButton), {
                              expand: "block",
                              color: "success",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (cancel()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(save)
                                }, null, 8, ["icon"]),
                                _createTextVNode(" Save ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonLoading), {
      "is-open": state.loading,
      message: "Please wait..."
    }, null, 8, ["is-open"])
  ]))
}
}

})